<mat-dialog-content>
  <ng-form *transloco="let t; prefix: 'form'" [formGroup]="form" novalidate>
    @if (marketReport.propertyDetails.contacts.length > 1) {
      <mat-form-field class="w-full">
        <mat-label>{{ t('label.select-contact') }}</mat-label>
        <mat-select [value]="marketReport.propertyDetails.contacts[0]" (selectionChange)="selectContact($event.value)">
          @for (contact of marketReport.propertyDetails.contacts; track contact) {
            <mat-option [value]="contact">
              {{ contact.fullName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (type === marketReportCommunicationTypeEnum.email) {
      <mat-form-field class="w-full">
        <mat-label>{{ t('label.email') }}</mat-label>
        <input type="email" [placeholder]="t('placeholder.email-example')" matInput formControlName="email" />
        <mat-error />
      </mat-form-field>
    }

    @if (type === marketReportCommunicationTypeEnum.sms) {
      <mat-form-field class="w-full">
        <mat-label>{{ t('label.mobile') }}</mat-label>
        <input type="tel" [placeholder]="t('placeholder.mobile-example')" matInput formControlName="phone" />
        <mat-error />
      </mat-form-field>
    }

    @if (type === marketReportCommunicationTypeEnum.email) {
      <mat-form-field class="w-full">
        <mat-label>{{ t('label.email-subject') }}</mat-label>
        <input type="text" matInput formControlName="subject" />
        <mat-error />
      </mat-form-field>
    }

    <mat-form-field class="w-full">
      <mat-label>{{ t('label.message') }}</mat-label>
      <textarea type="text" class="h-40" matInput formControlName="content"></textarea>
      <mat-error />
    </mat-form-field>

    <mat-form-error [control]="form" />

    <p class="flex justify-between">
      <button type="button" (click)="cancel()" mat-button color="primary">{{ 'action.cancel' | transloco }}</button>
      <!-- TODO Preview -->
      <button type="submit" (click)="send()" mat-raised-button color="primary">{{ 'action.send' | transloco }}</button>
    </p>
  </ng-form>
</mat-dialog-content>
